<template>
  <transition name="slide">
    <b-row >
        <!-- News publish -->
        <b-col xl="6" md="12" sm="12">
          <b-card :header="header.published" >
            <b-table  :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="newsPublishedArray" :fields="fields" :current-page="currentPage" :per-page="perPage">
                    <template slot="title" slot-scope="data">
                  <strong>{{data.item.val().title}}</strong>
                </template>
                <template slot="created" slot-scope="data">
                  <strong>{{new Date(data.item.val().created).toGMTString()}}</strong>
                </template>
                <template slot="modified" slot-scope="data">
                  <strong>{{new Date(data.item.val().modified).toGMTString()}}</strong>
                </template>
                <template slot="viewButton" slot-scope="data">
                  <b-button :value="data.item" v-on:click="rowClickedEditPublished(data.item)" block variant="primary">Edit</b-button>
                  <b-button :value="data.item" v-on:click="rowClickedNoPublish(data.item)" block variant="primary">No publish</b-button>
                </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(newsPublished)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              <!-- <b-row class="align-items-center">
                <b-col xl= "4" sm="6" md="4" class="mb-3 mb-xl-0" >
                  <b-button v-on:click="addNewsButton" block variant="primary">Add News</b-button>
                </b-col>
              </b-row> -->
            </nav>
          </b-card>
        </b-col> 
        <!-- News No publish -->
        <b-col xl="6" md="12" sm="12">
          <b-card :header="header.draft" >
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="newsDraftArray" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template slot="title" slot-scope="data">
                <strong>{{data.item.val().title}}</strong>
              </template>
              <template slot="created" slot-scope="data">
                <strong>{{new Date(data.item.val().created).toGMTString()}}</strong>
              </template>
              <template slot="modified" slot-scope="data">
                <strong>{{new Date(data.item.val().modified).toGMTString()}}</strong>
              </template>
              <template slot="viewButton" slot-scope="data">
                <b-button :value="data.item" v-on:click="rowClickedEditDraft(data.item)" block variant="primary">Edit</b-button>
                <b-button :value="data.item" v-on:click="rowClickedPublish(data.item)" block variant="primary">Publish</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(newsDraft)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              <b-row class="align-items-center">
                <b-col xl= "4" sm="6" md="4" class="mb-3 mb-xl-0" >
                  <b-button v-on:click="addNewsButton" block variant="primary">Add News</b-button>
                </b-col>
            </b-row>
            </nav>
          </b-card>
        </b-col>
    </b-row>
  </transition>
</template>

<script>
import { db } from '@/config/devowqlo';
import _ from 'underscore'
import VueDraggable from 'vue-draggable'
import { shuffleArray } from '@/shared/utils'

export default {
  components: {
    VueDraggable
  },
  name: 'News',
  firebase: {
    newsPublished: db.ref('news/published'),
    newsDraft: db.ref('news/draft')
  },
  props: {
    caption: {
      type: String,
      default: 'News'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      //items: teamsData.filter((team) => team.id < 10),
      // items: [],
      // items: this.$firebaseRefs.teams,
      // items: this.getTeams(),
      header: {
        published: 'News published',
        draft: 'News draft'
      },
      fields: [
        {key: 'title'},
        {key: 'subtitle'},
        {key: 'created'},
        {key: 'modified'},
        {key: 'viewButton', label: 'Actions'}
      ],
      newsPublishedArray: [],
      newsDraftArray: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item",
        onDrop(e) {
          const targetGroupId = parseInt(e.droptarget.dataset.id);
          const itemIds = e.items.map(item => parseInt(item.dataset.id));
          updateItemsWithNewGroupId(itemIds, targetGroupId);
        }
      }
    }
  },
  
  created() {
    this.$firebaseRefs.newsPublished.
      on('value', (snap) => {
        this.newsPublishedArray = []
        snap.forEach(it => {
          this.newsPublishedArray.push(it)
        }) 
      });
    
    this.$firebaseRefs.newsDraft.
    on('value', (snap) => {
      this.newsDraftArray = []
      snap.forEach(it => {
       this.newsDraftArray.push(it)
      }) 
    });
  },
  methods: {
    getRowCount (news) {
      return news.length

    },
    newsLink (id, isPublished) {
      return `news/${id}/${isPublished}`
    },
    rowClickedEditPublished (news) {
      const newsLink = this.newsLink(news.key, true)
      this.$router.push({path: newsLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    rowClickedEditDraft(news) {
      const newsLink = this.newsLink(news.key, false)
      this.$router.push({path: newsLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addNewsButton () {
      this.$router.push({path: 'news/addnews'})
    },
        // NEW!!
    notifyAllUsers(type, typeId, typeName, action) {  
      const dateNow = Date.now()

      var notificationModel = {
        type: type ,
        typeId: typeId,
        typeName: typeName,
        action: action,
        timestamp: dateNow,
         viewed: false 
      }

      console.log("<-- NOTIFY ALL USERS");
      console.log(notificationModel);
      
        db.ref('users').child('parents').once('value', (snapParents) => {
          db.ref('users').child('coaches').once('value', (snapCoaches) => {
            db.ref('users').child('players').once('value', (snapPlayers) => {
            
            console.log("Notifing coaches..."); 
            snapCoaches.forEach((childSnapshot) => {
              var coachKey = childSnapshot.key;   
              db.ref('userNotifications').child(coachKey).child('notifications').push(notificationModel)
            })  

            console.log("Notifing coaches... ");
            snapPlayers.forEach((childSnapshot) => {
              var playerKey = childSnapshot.key;
              db.ref('userNotifications').child(playerKey).child('notifications').push(notificationModel)
            })

            console.log("Notifing parents...");
            snapParents.forEach((childSnapshot) => {
              var parentKey = childSnapshot.key;
              db.ref('userNotifications').child(parentKey).child('notifications').push(notificationModel)
            })
          })
        })
      })   
    },

    rowClickedPublish (newsData) {
      var dateNow = Date.now()

      var newsModel = { 
        title: newsData.val().title,
        subtitle: newsData.val().subtitle,
        description: newsData.val().description,
        contentHtml: newsData.val().contentHtml,
        sourceUrl: newsData.val().sourceUrl,
        mediaUrl: newsData.val().mediaUrl,
        thumbMediaUrl: newsData.val().thumbMediaUrl,
        created: dateNow,
        modified: dateNow
      }

      this.$firebaseRefs.newsPublished.child(newsData.key).set(newsModel)
      this.$firebaseRefs.newsDraft.child(newsData.key).set(null)

      // NEW!!
      // params: type, typeId, typeName, action
      this.notifyAllUsers('news', newsData.key, newsModel.title, "created")

    },

    rowClickedNoPublish (newsData) {
       this.$firebaseRefs.newsDraft.child(newsData.key).set(newsData.val())
       this.$firebaseRefs.newsPublished.child(newsData.key).set(null)
    },
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
